<template>
  <BaseButton primary outline small @click="onRequestApproval"> Request Approval </BaseButton>
</template>

<script>
import { projectAssetApprovalRequestsClient } from '@/api/clients';

export default {
  props: {
    approvalClaimId: {
      type: String,
      required: true,
    },
    projectAssetId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async onRequestApproval() {
      this.loading = true;
      try {
        await projectAssetApprovalRequestsClient.store(this.projectAssetId, {
          approval_claim_id: this.approvalClaimId,
        });

        this.$emit('approval-request-created');
      } catch (error) {
        // handle error
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
